@if (value) {
    <img [width]="column.width" class="inline-block h-auto max-h-28 max-w-fit pointer-events-none object-scale-down" [src]="value"/>
}
